import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <h1>Dashboard</h1>
      <div className="dashboard-grid">
        <Link to="/vacancies" className="dashboard-card">
          <h2>Browse Vacancies</h2>
          <p>Find your next opportunity</p>
        </Link>
        <Link to="/applications" className="dashboard-card">
          <h2>My Applications</h2>
          <p>Track your applications</p>
        </Link>
        <Link to="/saved" className="dashboard-card">
          <h2>Saved Vacancies</h2>
          <p>View saved jobs</p>
        </Link>
        <Link to="/profile" className="dashboard-card">
          <h2>Profile</h2>
          <p>Manage your profile</p>
        </Link>
      </div>
    </div>
  );
};

export default Dashboard;


